webpackJsonp([86186464225756],{

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/gay-parade-banner.9d23b66a.jpg";

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(13);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _youtubeEmbedVideo = __webpack_require__(55);
	
	var _youtubeEmbedVideo2 = _interopRequireDefault(_youtubeEmbedVideo);
	
	var _gayParadeBanner = __webpack_require__(473);
	
	var _gayParadeBanner2 = _interopRequireDefault(_gayParadeBanner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AsylumSeekerPost = function AsylumSeekerPost(props) {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            _reactHelmet2.default,
	            null,
	            _react2.default.createElement(
	                'title',
	                null,
	                'Gay Asylum Seeker | Deportation Concern | Portsmouth'
	            ),
	            _react2.default.createElement('meta', { name: 'description', content: 'AsylumSeekerPost Page' })
	        ),
	        _react2.default.createElement(
	            'div',
	            { id: 'main', className: 'alt' },
	            _react2.default.createElement(
	                'section',
	                { id: 'one' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'inner' },
	                    _react2.default.createElement(
	                        'header',
	                        { className: 'major' },
	                        _react2.default.createElement(
	                            'h1',
	                            null,
	                            'MP says'
	                        ),
	                        _react2.default.createElement(
	                            'h3',
	                            null,
	                            'he has grave concerns over a gay constituent'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'image main' },
	                        _react2.default.createElement('img', { src: _gayParadeBanner2.default, alt: '' })
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Mr Robert Segwanyi from Uganda who faces deportation on Wednesday (10th August) back to Uganda and says he fled to the UK because he was tortured due to his sexuality by the police there and now fears for his safety if he has to return.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Homosexuality is illegal in Uganda and can mean a sentence of up to 14 years in prison. One of Britain\'s leading professors of psychiatry, Prof Katona says that he thinks that Mr Segwanyi has suffered from Post Traumatic Stress Disorder (PTSD) and is gay but this is disputed by the UKBA. Prof Katona, though says no actor could fake the symptoms of PTSD that Mr Segwanyi presented. Among the problems that Mike Hancock believes there are with this case include:'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Misrepresentation in Mr Segwanyi\'s appeal by the Immigration Judge of the evidence of one of Britain\'s leading professors of psychiatry - Professor Katona. New evidence including from John Bosco Nyombi, a gay Ugandan who won his asylum case and who has recently met Mr Segwanyi Incorrect application of a recent Supreme Court Judgement on gay asylum seekers (known as HJ & HT v SSHD). Continued old-fashioned attitudes by immigration judges and a system that does not allow for the extreme nervousness that LGBT people may have in admitting their sexuality to people in authority following their experiences. '
	                    ),
	                    _react2.default.createElement(_youtubeEmbedVideo2.default, { videoId: 'ZihWtuB8BSE',
	                        suggestions: false,
	                        width: '100%',
	                        height: '450px' }),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'A report by the gay rights organisation Stonewall produced in conjunction with the Law Society, found that many Lesbian, Gay, Bisexual and Transgender (LGBT) people: are not granted protection because of fundamental errors of judgement and presumptions made by UK Border Agency (UKBA) staff and judges about sexual orientation."It found that some judges were "old fashioned" in their attitudes. The quotes an anonymous UKBA officers as saying: "Some will also bend over backwards to make sure the Home Office wins the case." Mr Hancock feels that this old-fashioned attitude was present in Mr Segwanyi\'s case.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'John Bosco Nyombi won his asylum case as a gay Ugandan in 2009. He recently met Mr Segwanyi at Haslar Detention Centre. Mr Bosco is quoted as saying: "When I met him face to face, it was obvious that Robert is gay. The way he was talking, the mannerism and mentioning some of Ugandan gay guys I know from Uganda. Robert told me what he has been through and from my experience I knew it did happen to him as it happened to me when people in Uganda came to know about my sexuality."'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'A leading Professor Katona has said that in his opinion Mr Segwanyi is gay and has suffered from Post Traumatic Stress Disorder (PTSD). Unfortunately there was a factual error in the first appeal when it was stated by the immigration judge that said Professor Katona could not say whether Mr Segwanyi was gay. Prof Katona says that this was "with respect incorrect": "he does" consider Mr Segwanyi to be gay.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Following a Supreme Court judgement, the Home Secretary, Theresa May said: "I do not believe it is acceptable to send people home and expect them to hide their sexuality to avoid persecution." Mike Hancock said: "I understand that Mr Segwanyi\'s lawyer is putting in further representations.  And I hope that between the legal system and the UK Border Agency, there can finally be some justice for Mr Segwanyi. There have been factual errors by immigration judges in this case. '
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'The Immigration Judge misrepresented evidence from Professor Katona, one of the country\'s leading professors of psychiatry on whether he considers Mr Segwanyi to be gay:  he does. This needs to be corrected. Prof Katona also considers that he suffers from Post Traumatic Stress Disorder. In fact he says that no actor could fake the symptoms Mr Segwanyi presented.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        '"Unfortunately in recent months following the death of gay activist, David Kato, things have got more dangerous for gay people in Uganda. People who have met him including John Bosco Nyombi say that it is "obvious" that Mr Segwanyi is gay. This is all new evidence and should be treated as a fresh claim by the courts and the Home Office. I hope that justice can now prevail."'
	                    ),
	                    _react2.default.createElement(
	                        'a',
	                        { href: '/#header', className: 'button' },
	                        'BACK HOME'
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = AsylumSeekerPost;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-news-gay-asylum-seeker-deportation-js-41caa4c8dddacf36a7da.js